module.exports = __webpack_public_path__ + "img/weihu.b03a4870.png";